import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";
import type { ProductDependenciesConfig } from "../../types/productDependencies";

export default function useProductDependencies() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    function useList() {
        return useQuery<ProductDependenciesConfig>({
            queryKey: ["product-dependencies"],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/product-dependencies/list");
                return parseSuccessResponseData(response) as ProductDependenciesConfig;
            },
        });
    }

    function useSave() {
        return useMutation({
            mutationFn: async (data: ProductDependenciesConfig) => {
                const response = await axiosPrivate.put("/v1/product-dependencies/save", data);
                return parseSuccessResponseData(response);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["product-dependencies"] });
            },
        });
    }

    return { useList, useSave };
}
